import * as React from 'react';
import { Pressable, ScrollView, View } from 'react-native';
import { DismissibleModal } from '@/components/ui/dismissible-modal';
import { Text } from '@/components/ui/text';
import type { EligibleTour } from '../types';

interface TourDigestModalProps {
  visible: boolean;
  tours: EligibleTour[];
  onTakeTour: (tour: EligibleTour) => void;
  onSkipTour: (tour: EligibleTour) => void;
  onClose: () => void;
}

function TourDigestModal({
  visible,
  tours,
  onTakeTour,
  onSkipTour,
  onClose,
}: TourDigestModalProps) {
  return (
    <DismissibleModal
      visible={visible}
      onClose={onClose}
      title="What's New"
      testID="tour-digest-modal"
    >
      <ScrollView showsVerticalScrollIndicator={false}>
        {tours.map((tour) => (
          <View
            key={tour.slug}
            className="mb-4 pb-4 border-b border-border last:border-b-0 last:mb-0 last:pb-0"
          >
            <Text className="text-card-foreground font-semibold text-base mb-1">
              {tour.title}
            </Text>
            {tour.description !== null && (
              <Text className="text-muted-foreground text-sm mb-3">
                {tour.description}
              </Text>
            )}
            <View className="flex-row gap-2">
              <Pressable
                onPress={() => onTakeTour(tour)}
                accessibilityLabel={`Take Tour: ${tour.title}`}
                accessibilityRole="button"
                className="bg-primary rounded-lg py-2 px-4"
              >
                <Text className="text-primary-foreground font-semibold text-sm">
                  Take Tour
                </Text>
              </Pressable>
              <Pressable
                onPress={() => onSkipTour(tour)}
                accessibilityLabel={`Skip: ${tour.title}`}
                accessibilityRole="button"
                className="rounded-lg py-2 px-4"
              >
                <Text className="text-muted-foreground font-semibold text-sm">
                  Skip
                </Text>
              </Pressable>
            </View>
          </View>
        ))}
      </ScrollView>
    </DismissibleModal>
  );
}

export { TourDigestModal };
export type { TourDigestModalProps };
